

































import { computed, defineComponent, watch } from '@vue/composition-api';
import Login from '@components/loginAndRegister/Login/index';
import Reset from '@components/loginAndRegister/Reset/index';
import Register from '@components/loginAndRegister/Register/index';
import svgCom from '@components/Svg/index';
import request from '@utils/request';

export default defineComponent({
  name: 'LoginPage',
  components: {
    Login,
    Reset,
    Register,
    svgCom
  },
  setup(props, { root, attrs } ) {
    const { loginState } = attrs;
    console.log(loginState);
    watch(() => loginState, (newVal) => {
      if (newVal) {
        root.$router.push({ name: 'Home' });
      }
    }, { immediate: true });

    const type = computed(() => {
      return root.$route.params.type === undefined ? 'login' : root.$route.params.type;
    });    

    // 模板下载
    const onDownload = async () => {
      await request('login', 'downLoadFile', {fileName: 'PLATFORM_OPERATION_MANUAL'});
    };

    return {
      type,
      onDownload
    };
  },
});
